import { Handle } from "react-flow-renderer";
import styled, { css } from "styled-components";

export const EventStart = styled.div`
  width: 50.81px;
  height: 50.81px;
  box-shadow: 0 0 0 1.2px #42464c;
  border-radius: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: #fff;
  cursor: auto;

  &.critical {
    border: 4px solid #d93333 !important;
  }

  path {
    stroke: #42464c;
    stroke-width: 1px;
  }

  ${({ status }) =>
    status === "doing"
      ? css`
          background-color: #f9e169;
        `
      : status === "pending"
      ? css`
          background-color: #fff;
        `
      : status === "done"
      ? css`
          background-color: #a0f69e;
        `
      : null}
`;

export const HandleStyle = styled(Handle)`
  width: 8px;
  height: 8px;
  background: #42464c;
`;
